"use client"
import { cn } from "@/lib/utils";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState, useEffect } from "react";

export function InteractionTabs() {
    const currentPath = usePathname(); 
    const [activeLink, setActiveLink] = useState(currentPath); 
  
    useEffect(() => {
      if (currentPath === "/votacao/votos") setActiveLink("votos");
      if (currentPath === "/votacao/acompanhamentos") setActiveLink("acompanhamentos");
    }, [currentPath]);
    
    return (
        <div className="rounded-xl bg-white px-4 py-2">
          <div className="flex flex-col w-fit relative">
            <div className="flex w-fit gap-4 relative z-9 text-secondary">
              <Link
                className={cn("transition-colors duration-300", activeLink === "votos" && "text-primary")}
                href="/votacao/votos"
                onClick={() => setActiveLink("votos")}
              >
                Meus votos
              </Link>
              <Link
                className={cn("transition-colors duration-300", activeLink === "acompanhamentos" && "text-primary")}
                href="/votacao/acompanhamentos"
                onClick={() => setActiveLink("acompanhamentos")}
              >
                Acompanhando
              </Link>
            </div>
            <div className="bg-secondary w-full h-0.5 rounded absolute bottom-0 z-0" />
            <div
              className={cn(
                "absolute bottom-0 h-1 rounded bg-primary transition-all duration-300 -mb-[1px]",
                activeLink === "votos" && "left-0 w-[5.6rem]",
                activeLink === "acompanhamentos" && "left-[6.6rem] w-[8.3rem]"
              )}
            />
          </div>
        </div>
    )
}